import React, { useState, useEffect, useRef } from "react";
import styles from "./style.module.css";
import Typography from "../../components/Typography/Typography";
import { StoreBot, StoreModalClose } from "../../assets/svgs";

interface AIAssistantModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const AIAssistantModal: React.FC<AIAssistantModalProps> = ({ isOpen, onClose }) => {
    const [inputValue, setInputValue] = useState("");
    const modalRef = useRef<HTMLDivElement>(null);
    const overlayRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape' && isOpen) {
                onClose();
            }
        };

        const handleClickOutside = (e: MouseEvent) => {
            if (overlayRef.current && modalRef.current && 
                !modalRef.current.contains(e.target as Node) &&
                isOpen) {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Handle the AI assistant query here
        console.log("User query:", inputValue);
        // Clear input after submission
        // setInputValue("");
    };

    const handleQuickAction = (action: string) => {
        setInputValue(action);
    };

    return (
        <div className={styles.overlay} ref={overlayRef}>
            <div className={styles.modal} ref={modalRef}>
                <div className={styles.header}>
                    <Typography
                        variant="heading5"
                        fontFamily="satoshi"
                        weight="bold"
                        className={styles.headerTitle}
                    >
                        AI Assistant
                    </Typography>
                    <button 
                        className={styles.closeButton} 
                        onClick={onClose}
                        aria-label="Close modal"
                    >
                        <img
                            src={StoreModalClose}
                            alt="modal close icon"
                        />
                    </button>
                </div>

                <div className={styles.content}>
                    <div className={styles.tipIcon}>
                        <img
                            src={StoreBot}
                            alt="AI bot Icon"
                            className={styles.tipBotIcon}
                        />
                    </div>
                    
                    <div className={styles.tipSection}>
                        <div className={styles.tipContent}>
                            <Typography
                                variant="bodyRegular"
                                fontFamily="satoshi"
                                weight="regular"
                                className={styles.tipText}
                            >
                                <strong>Tip:</strong> A unique store name helps you stand out! Try combining words that represent your brand's personality.
                            </Typography>
                        </div>
                    </div>

                    <div className={styles.quickActionSection}>
                        <button
                            className={styles.quickActionButton}
                            onClick={() => handleQuickAction("I need help with my store creation")}
                        >
                            <Typography
                                variant="bodyRegular"
                                fontFamily="satoshi"
                                weight="regular"
                                className={styles.quickActionText}
                            >
                                I need help with my store creation
                            </Typography>
                        </button>
                    </div>
                </div>
                
                <div className={styles.inputSection}>
                    <form onSubmit={handleSubmit} className={styles.inputForm}>
                        <input
                            type="text"
                            placeholder="Ask me anything"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            className={styles.textInput}
                            autoFocus
                        />
                    </form>
                </div>
            </div>
        </div>
    );
};